// @flow
import { get } from 'utils/api';

export const ENDPOINT_APP_CONTEXT = '/app-context';

export const getAppContext = async (
  organizationId,
  propertyId,
  options = {},
) => {
  const url = `/portal/${organizationId}/${propertyId}${ENDPOINT_APP_CONTEXT}`;
  const response = await get(url, options);

  if (response.error) {
    throw response.error;
  }

  return response;
};
